/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Status_SyncingInputs */

const bn_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রাফিক সিঙ্কিং`)
};

const de_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkehrssynchronisierung`)
};

const el_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συγχρονισμός κυκλοφορίας`)
};

const en_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Syncing`)
};

const es_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización de tráfico`)
};

const fr_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation trafic`)
};

const hi_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैफ़िक सिंकिंग`)
};

const hu_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgalom szinkronizálása`)
};

const id_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronisasi Lalu Lintas`)
};

const it_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione del traffico`)
};

const ja_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラフィックの同期`)
};

const ko_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트래픽 동기화`)
};

const nl_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkeerssynchronisatie`)
};

const pl_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja ruchu`)
};

const pt_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização de tráfego`)
};

const ru_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация трафика`)
};

const sv_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafiksynkronisering`)
};

const tr_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik Senkronizasyonu`)
};

const uk_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронізація трафіку`)
};

const vi_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ hóa lưu lượng truy cập`)
};

const zh_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量同步`)
};

const zh_hant_cipher_status_syncing = /** @type {(inputs: Cipher_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量同步`)
};

/**
* | output |
* | --- |
* | "Traffic Syncing" |
*
* @param {Cipher_Status_SyncingInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_status_syncing = /** @type {((inputs?: Cipher_Status_SyncingInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Status_SyncingInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_status_syncing(inputs)
	if (locale === "de") return de_cipher_status_syncing(inputs)
	if (locale === "el") return el_cipher_status_syncing(inputs)
	if (locale === "en") return en_cipher_status_syncing(inputs)
	if (locale === "es") return es_cipher_status_syncing(inputs)
	if (locale === "fr") return fr_cipher_status_syncing(inputs)
	if (locale === "hi") return hi_cipher_status_syncing(inputs)
	if (locale === "hu") return hu_cipher_status_syncing(inputs)
	if (locale === "id") return id_cipher_status_syncing(inputs)
	if (locale === "it") return it_cipher_status_syncing(inputs)
	if (locale === "ja") return ja_cipher_status_syncing(inputs)
	if (locale === "ko") return ko_cipher_status_syncing(inputs)
	if (locale === "nl") return nl_cipher_status_syncing(inputs)
	if (locale === "pl") return pl_cipher_status_syncing(inputs)
	if (locale === "pt") return pt_cipher_status_syncing(inputs)
	if (locale === "ru") return ru_cipher_status_syncing(inputs)
	if (locale === "sv") return sv_cipher_status_syncing(inputs)
	if (locale === "tr") return tr_cipher_status_syncing(inputs)
	if (locale === "uk") return uk_cipher_status_syncing(inputs)
	if (locale === "vi") return vi_cipher_status_syncing(inputs)
	if (locale === "zh") return zh_cipher_status_syncing(inputs)
	return zh_hant_cipher_status_syncing(inputs)
});